import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/CaseDictationReports'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const GetItem = (fromModule, objectId, isGetSummary = false) => {
  return ApiRequest.get(
    `${BaseRoute}?fromModule=${fromModule}&objectId=${objectId}&isGetSummary=${isGetSummary}`
  )
}

const UpdateDictationFromIME = data => {
  return ApiRequest.put(`/app/assessments/${data.id}/dictation-report`, data)
}
const UpdateDictationFromSupp = params => {
  return ApiRequest.put(
    `/app/supplementary/${params.id}/dictation-report`,
    params
  )
}
const SetPic7 = (objectId, fromModuleType, picUserId = null) => {
  return ApiRequest.put(
    `${BaseRoute}/${objectId}/SetPic7?fromModule=${fromModuleType}&picUserId=${
      picUserId ? picUserId : ''
    }`
  )
}

const GenerateReportTemplate = (objectId, fromModule, formData) => {
  return ApiRequest.post(
    `${BaseRoute}/generateReportTemplate?objectId=${objectId}&fromModule=${fromModule}`,
    formData,
    {
      responseType: 'blob', // Important for file download
    }
  )
}

const API = {
  ...baseFunctions,
  GetItem,
  UpdateDictationFromIME,
  UpdateDictationFromSupp,
  SetPic7,
  GenerateReportTemplate,
}
export default API
